module.exports = __webpack_public_path__ + "img/logo_white.e4dd2c3b.png";